/**
 * バージョン管理ページ用のスクリプト
 */

if (is_route('version.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        version_event_set();
    });
}

/**
 * ページ読み込み時のイベント設定
 */
window.version_event_set = function () {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id']);
    });

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });

    /*---- 一括削除チェックボックス操作時 ----*/

    // 一括のチェックボックスクリック時
    $(document).on('click', '#version-all-delete', function () {
        $(".version-delete").prop('checked', $(this).prop('checked'));
    });
    // 一覧のチェックボックスクリック時
    $(document).on('click', '.version-delete', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });
    // 一括・一覧のチェックボックス変更時
    $(document).on('change', '#version-all-delete, .version-delete', function () {
        // 一覧のチェック状態を判定し削除ボタンを有効化
        $('#version-multi-delete-button').prop('disabled', ($('.version-delete:checked').length == 0));
    });

    /*---- 削除確認時 ----*/

    // 一括削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        var ids = ($(this).data('id') == null ? [] : [$(this).data('id')]);
        if ($(this).data('id') == null) {
            $('.version-delete[name="ids[]"]:checked').map(function() {
                ids.push($(this).val());
            });
        }
        if (ids.length > 0) {
            _modal.create_with_data(this, 'confirm-modal', {'ids': ids});
        }
    });

    /*---- 削除処理 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal', function(results) {
            _modal.hide('#version-setting-modal');
        });
    });
}
